import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@redux/index';

export const selectWeb3 = (state: RootState) => state.web3;

export const getWeb3 = createSelector(
  selectWeb3,
  (state) => state.web3
);

export const isWalletConnectActive = createSelector(
    selectWeb3,
    (state) => state.isWalletConnect
  ); 

export const getPlatformTokenAmount = createSelector(
    selectWeb3,
    (state) => state.platformTokenAmount
  ); 

export const getUnlockedVestingAmount = createSelector(
    selectWeb3,
    (state) => state.unlockedVestingAmount
); 